import * as React from "react"
import { useEffect } from "react"
import { Grid } from "@mui/material"

import PageWrapper from "Pages/@PageWrapper"
import {MONITORING_ROUTES} from "@constants"
import {isSystemBusy} from "@signals";
import {monitoringAdminIsEmpty, resetMonitoringAdmin } from "./@signals";
import MonitoringAdminTable from "./Table";
import MonitoringAdminReportDetailsModals from "./InfoModal";
import MonitoringAdminReportsDrawer from "./FiltersDrawer";


export default function MonitoringAdminPage() {

    useEffect(() => {
        return () => resetMonitoringAdmin()
    },[])

    return <PageWrapper
        isEmpty={monitoringAdminIsEmpty.value}
        head={`DIP Insight | ${MONITORING_ROUTES.ADMIN_TITLE}`}
        title={MONITORING_ROUTES.ADMIN_TITLE}
        subtitle={MONITORING_ROUTES.ADMIN_SUBTITLE}
        hasErrors={isSystemBusy.value}
        actions={null}
    >
        <Grid container spacing={4} sx={{ mt: 1 }}>
            <Grid item xs={12}>
                <MonitoringAdminTable />
            </Grid>
            <MonitoringAdminReportDetailsModals />
            <MonitoringAdminReportsDrawer />
        </Grid>
    </PageWrapper>
}